/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';

import userApi from '@/api/userapi';
import Utils from '@/utils/utils';
import raysserveapi from '@/api/raysserveapi';

import setPermission from './menus';
import * as Cookie from '@/utils/cookie';
import { message } from '@/components/AntD';
// import ailimiterapi from '@/api/ailimiterapi';
import PAGES from '@/constants/page';
import audiobookapi from '@/api/audiobookapi';

export default {
  namespace: 'user',
  state: Immutable({
    userInfo: {
      permissionMenus: [],
      flatPermissionMenus: []
    },
    coinInfo: {},
    channels: [],
    adviserInfo: {

    },
    partyNameList: [],
    memberAccountList: {},
    roleList: [],
    labelList: [],
    memberBaseInfo: {},
    industryCaseInfo: {},
    judgeTrialAccount: {}
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    // 获取用户信息
    getUserInfo(hasCompanyIp) {
      return {
        type: 'user/update/updateUserInfo',
        field: 'userInfo',
        promise: userApi.getUserInfo()
          .then(data => {
            const { permissionVOList, partyId, ...userInfo } = data;
            return Object.assign(data, {
              hasCompanyIp: hasCompanyIp,
              permissionMenus: setPermission(userInfo, hasCompanyIp),
              flatPermissionMenus: Utils.flatMap(setPermission(userInfo, hasCompanyIp))
            });
          })
      };
    },
    // 获取用户是否有剩余合成字数
    judgeTrialAccount() {
      return {
        type: 'user/update/judgeTrialAccountInfo',
        field: 'judgeTrialAccount',
        promise: raysserveapi.judgeTrialAccount()
      };
    },
    agentInfo() {
      return {
        type: 'user/update/agentInfo',
        field: 'agentInfo',
        promise: raysserveapi.agentInfo()
      };
    },

    getAdviserInfo() {
      return {
        type: 'user/update/updateAdviserInfo',
        field: 'adviserInfo',
        promise: userApi.getAdviserInfo()
      };
    },
    getChannels() {
      return {
        type: 'user/update/getChannels',
        field: 'channels',
        promise: userApi.getChannels()
      };
    },
    // 登录
    login(payload) {
      return {
        promise: userApi.login(payload)
      };
    },
    getCoinInfo() {
      return {
        type: 'user/update/updateCoinInfo',
        field: 'coinInfo',
        promise: audiobookapi.getAiAudioPermission()
      };
    },
    logout() {
      return {
        promise: new Promise(() => {
          // 直接退出系统
          Cookie.saveCookie('');  // 清除token
          message.success('注销成功');
          window.location.href = PAGES.LOGIN;
        })
      };
    }
  }
};
